import React, { useState, useEffect } from "react";
import { Modal, ModalButtonID } from '../ui/components';
import { FailureType } from '../shared/types';
import { parseURI } from '../shared/utils/URI';
import { useSubscribe } from '../hooks';
import { error$ } from '../observables/error';
import { basename } from '../utils/path';
import { createQueue } from '../observables/queue';
export default function ConfirmDeletion() {
    const [files, setFiles] = useState([]);
    const [names, setNames] = useState([]);
    const [isLocal, setLocal] = useState(true);
    useEffect(() => {
        setLocal(files.length > 0 && files[0].substring(0, 5) == 'file:');
        setNames(files.map(u => basename(parseURI(u).path)));
    }, [files]);
    useSubscribe(() => error$.subscribe(error => {
        if (error.type == FailureType.ConfirmDeletion) {
            setFiles(error.files);
        }
    }));
    const buttons = [
        {
            id: ModalButtonID.Cancel,
            label: 'Cancel'
        },
        {
            id: ModalButtonID.Ok,
            label: isLocal ? 'Move to Trash' : 'Delete Forever'
        }
    ];
    const onClose = (id) => {
        if (id == ModalButtonID.Ok) {
            window.f5.remove(files).then(id => createQueue(id));
        }
        setFiles([]);
    };
    return React.createElement(React.Fragment, null, files.length > 0 &&
        React.createElement(Modal, { buttons: buttons, onClose: onClose },
            React.createElement("div", { className: 'modal-content', style: { textAlign: 'center' } },
                React.createElement("p", null,
                    React.createElement("strong", null, names.length > 1 ?
                        `Are you sure you want to delete ${names.length} files/directories and their contents?` :
                        React.createElement("span", null,
                            "Are you sure you want to delete ",
                            React.createElement("br", null),
                            " '",
                            names[0],
                            "'?"))),
                React.createElement("p", null,
                    React.createElement("i", null, isLocal ?
                        `You can restore ${names.length > 1 ? 'them' : 'it'} from the Trash.` :
                        'This action is irreversible!')))));
}
